import { formatTimeString } from '~libs/dayjs';

import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view';
import { linkCellRender } from '~components/table-view/columnRenderers';
import { getEncryptedColumnProps } from '~libs/encryptionSettings';

export const getColumns = (onOpen: (row: Row) => void, getHref?: (row: Row) => string): Column[] => [
  {
    id: 'reference_number',
    header: 'Reference Number',
    type: 'text',
    renderReadOnly: linkCellRender(onOpen, faEdit, undefined, getHref),
  },
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
    ...getEncryptedColumnProps(),
  },
  {
    id: 'date',
    header: 'Date',
    type: 'date',
  },
  {
    id: 'start_time',
    header: 'Start Time',
    type: 'text',
    deriveValue: ({ start_time }) => formatTimeString(start_time),
  },
  {
    id: 'end_time',
    header: 'End Time',
    type: 'text',
    deriveValue: ({ end_time }) => formatTimeString(end_time),
  },
  {
    id: 'status.name',
    header: 'Status',
    type: 'text',
    deriveValue: (row) => row.status?.name ?? '',
  },
  {
    id: 'company.name',
    header: 'Company',
    type: 'text',
    deriveValue: (row) => row.company?.name ?? '',
  },
  {
    id: 'user.full_name',
    header: 'Care Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
  {
    id: 'client.referrer_name',
    header: 'Referrer',
    type: 'text',
    deriveValue: (row) => row.client?.referrer_name ?? '',
  },
  {
    id: 'package_fixed.name',
    header: 'Package',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.name ?? '',
  },
  {
    id: 'service_type.name',
    header: 'Service Type',
    type: 'text',
    deriveValue: ({ service_type }) => {
      if (!service_type) return '';
      const deletedSuffix = service_type.deleted ? ' - DELETED' : '';
      return `${service_type.name}${deletedSuffix}`;
    },
  },
];

export default getColumns;
